import Vue from 'vue';

// VIDEO METHODS

export const CreateVideo = body => Vue.http.post('/api/v1/video', body)
  .then(response => response.json());

export const GetVideoUploadParams = id => Vue.http.get(`/api/v1/video/upload/${id}`)
  .then(response => response.json());

export const UploadVideo = (url, video) => Vue.http.put(url, video)
  .then(response => response);

export const PatchVideo = (id, body) => Vue.http.patch(`/api/v1/video/${id}`, body);

export const GetVideoById = id => Vue.http.get(`/api/v1/video/${id}`)
  .then(response => response.json());

export const GetVideoToPlay = () => Vue.http.get('/api/v1/videoPlay')
  .then(response => response.json());

export const MarkVideoAsWatched = id => Vue.http.get(`/api/v1/videoPlay/watched/${id}`)
  .then(response => response);

// AUTH/USER METHODS

export const GetUsers = (() => Vue.http.get('/api/v1/user').then(response => response.json()));

export const GetCurrentUser = (() => Vue.http.get('/api/v1/user/me').then(response => response.json()));

export const Register = ({ username, fullname, password, credit }) => Vue.http.post('/api/v1/user', {
  username,
  fullname,
  password,
  credit,
}).then(response => response.json());

export const UpdateUserApproval = ({ id, approved }) => Vue.http.patch(`/api/v1/user/${id}`, { approved }).then(response => response);

export const Login = ({ username, password }) => Vue.http.post('/login_check', {
  username,
  password,
}).then(response => response);

export const PasswordReset = ({ email }) => Vue.http.post('/api/v1/password_reset', { email });

export const PasswordResetTwo = ({ token, password }) => Vue.http.post('/api/v1/password_reset2', { token, password });

export const STATUS_UPLOADING = 'Uploading';
export const STATUS_UPLOADING_DONE = 'Complete';
export const STATUS_CANCELLED = 'Cancelled';



// WEBPACK FOOTER //
// ./src/services/api.js